import React, { useState } from "react";
import { SVGS } from "../../assets/svgs";
import { Button, CancelButton } from "../button/button";
import { ContentsContainer } from "../card/cardcontainer";
import { IconWrapper } from "../iconWrapper/wrapper";
import { InputDate, InputSelect, InputText } from "../inputs/inputs";
import { LightText } from "../lightText/lighttext";
import { BoldText, NormalText } from "../normalText/normalText";
import { PaymentSuccess, PaymentFailed, PlsWait } from "../modal/container";
import styles from "./bank.module.css";
import styled from "styled-components";

const bankList = [
  {
    bankId: "Waya Bank",
    bankName: "Waya Bank",
  },
];

const { bankIcon, Ussd } = SVGS;
export const Bank = ({ title }) => {
  const [selectedBank, setSelectedBank] = useState("");
  const [bankAccountNumber, setBankAcountNumber] = useState();
  const [modals, setModals] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [userOTP, setUserOTP] = useState();
  const [userBVN, setUserBVN] = useState();
  const [tabs, setTabs] = useState(1);

  const submitStep1 = () => {
    const bankDetails = {
      bankName: selectedBank,
      accountNumber: bankAccountNumber,
    };
    console.log(bankDetails);
    setTabs(2);
  };

  const submitStep2 = () => {
    const userDetails = {
      customerBVN: selectedBank,
      accountNumber: userBVN,
    };
    console.log(userDetails);
    setTabs(3);
  };
  const submitOTP = () => {
    console.log(userOTP);
    setModals("wait");
  };

  return (
    <ContentsContainer>
      {tabs === 1 && (
        <div className={styles.contentsBetween}>
          <div className={styles.text}>
            <div style={{ marginBottom: 10 }}>
              <IconWrapper pad={20}>
                <img src={bankIcon} alt="" />
              </IconWrapper>
            </div>

            <BoldText align="center" size={14}>
              Select your bank provider to make payment
            </BoldText>
          </div>
          <div className={styles.inputContainer2}>
            <InputSelect
              code={false}
              values={bankList}
              setSelectedBank={setSelectedBank}
            />
            <InputText
              placeholder="Bank Account Number (11 Digits)"
              // onchange={(e) => setBankAcountNumber(e.target.value)}
              value={bankAccountNumber ?? ""}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                if (inputValue.length <= 11) {
                  setBankAcountNumber(e.target.value);
                }
              }}
              type="number"
              pattern="\d{10}"
            />
          </div>
          <div className={styles.buttonContainer}>
            <Button
              type={"button"}
              text="Confirm Account"
              active={true}
              onClick={submitStep1}
              disabled={!bankAccountNumber || !selectedBank}
            />
          </div>
        </div>
      )}
      {tabs === 2 && (
        <div className={styles.contentsBetween}>
          <div className={styles.text}>
            <div style={{ marginBottom: 10 }}>
              <IconWrapper pad={20}>
                <img src={Ussd} alt="" />
              </IconWrapper>
            </div>
            <BoldText align="center" size={14}>
              Please enter your BVN
            </BoldText>
          </div>
          <div className={styles.inputContainer2}>
            <InputText
              placeholder="Bank Account Number (11 Digits)"
              value={userBVN ?? ""}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                if (inputValue.length <= 11) {
                  setUserBVN(e.target.value);
                }
              }}
              type="number"
              pattern="\d{11}"
            />
          </div>
          <div className={styles.buttonContainer2}>
            <Button
              type={"button"}
              text="Authorize Payment"
              active={true}
              onClick={submitStep2}
              disabled={!userBVN}
            />
            <CancelButton text="cancel" onClick={() => setTabs(1)} />
          </div>
        </div>
      )}
      {/* DOB UNComment on request  */}
      {/* {tabs === 3 && (
        <div className={styles.contentsBetween}>
          <div className={styles.text}>
            <div style={{ marginBottom: 10 }}>
              <IconWrapper pad={20}>
                <img src={bankIcon} alt="" />
              </IconWrapper>
            </div>
            <BoldText align="center" size={14}>
              Enter your date of birth
            </BoldText>
          </div>
          <div>
            <NormalText align="center" size={14}>
              Kindly ensure your date of birth match with the one on your BVN
            </NormalText>
          </div>
          <div className={styles.inputContainer3}>
            <InputSelect width={100} code={false} />
            <InputDate width={50} />
            <InputDate width={100} />
          </div>
          <div className={styles.buttonContainer2}>
            <Button
              text="Authorize Payment"
              active={true}
              onclick={() => setTabs(4)}
            />
            <CancelButton text="cancel" onclick={() => setTabs(1)} />
          </div>
        </div>
      )} */}
      {tabs === 3 && (
        <div className={styles.contentsBetween}>
          <div className={styles.text}>
            <div style={{ marginBottom: 10 }}>
              <IconWrapper pad={20}>
                <img src={Ussd} alt="" />
              </IconWrapper>
            </div>
            <BoldText align="center" size={14}>
              To confirm that you own this account, kindly enter the OTP sent to
              your phone registered with your BVN
            </BoldText>
          </div>
          <div className={styles.inputContainer4}>
            {/* <InputText
              under={true}
              underText={`You should receive a token code in less than 5 mins`}
              placeholder="Enter OTP here"
            /> */}
            <InputText
              placeholder="Enter OTP here"
              value={userOTP ?? ""}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                if (inputValue.length <= 6) {
                  setUserOTP(e.target.value);
                }
              }}
              type="number"
              pattern="\d{6}"
            />
          </div>
          <div className={styles.buttonContainer2}>
            {/* <Button
              text="Authorize Payment"
              active={true}
              onclick={() => setTabs(1)}
            /> */}

            <Button
              type={"button"}
              text="Authorize Payment"
              active={true}
              onClick={submitOTP}
              disabled={!userOTP}
            />

            <CancelButton text="cancel" onClick={() => setTabs(1)} />
          </div>
        </div>
      )}{" "}
      {modals === "success" && (
        <ModalContainer>
          <PaymentSuccess />
        </ModalContainer>
      )}
      {modals === "failed" && (
        <ModalContainer>
          <PaymentFailed />
        </ModalContainer>
      )}
      {modals === "wait" && (
        <ModalContainer>
          <PlsWait />
        </ModalContainer>
      )}
    </ContentsContainer>
  );
};

const ModalContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  /* width: 100%; */
  /* height: 100vh; */
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;
